import vinrealSelectorVdp from './vinrealSelectorVdp';

const linkTypeMapping = {
	'vdp-slideshow': {
		page: {
			vinreal: vinrealSelectorVdp('click')
		},
		onclick: {
			onclick: '{inventoryType}:si:vehicle details:photo scroll',
			onclickLinkName:
				'{client}:{inventoryType}:si:vehicle details:content:action:{nameplate}'
		}
	},
	'ford-download': {
		onclick: {
			onclick: 'brochures:pdf download',
			onclickLinkName: '{client}:brochures:pdf download'
		},
		page: {
			pageName: '{client}:brochures:pdf',
			siteSection: 'brochures',
			hierarchy: 'shopping tools:brochures',
			tool: 'event:pdf brochure',
			toolDescriptor: 'pdf'
		},
		user: {
			leadType: 'brochure:anonymous:pdf'
		},
		directCall: 'global-download'
	},
	incentive: {
		onclick: {
			onclickLinkName: '{client}:{inventoryType}:search inventory:'
		},
		page: {
			pageName: '{client}:special offers:request info'
		},
		directCall: 'vehicle-onclick'
	},
	'ford-mobile-learn-more': {
		onclick: {
			onclick: 'referral:flmo:fp:rewards',
			onclickLinkName: 'referral:exit',
			referredTo: 'flmo:fp:rewards'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	referral: {
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclickLinkName: 'referral:exit'
		},
		directCall: 'referral-exit'
	},
	'video-popup': {
		onclick: {
			onclick: '{inventoryType}:si:vls:content:video play',
			onclickLinkName:
				'{client}:{inventoryType}:si:vls:content:action:{nameplate}'
		},
		page: {
			pageName: '{client}:new:vrfq:si:vin:video popup'
		},
		directCall: 'vehicle-onclick'
	},
	'windowsticker-vlp': {
		onclick: {
			onclickLinkName:
				'{client}:{inventoryType}:si:vls:view window sticker'
		},
		page: {
			tool: 'event:window sticker',
			hierarchy: 'shopping tools:search inventory:{inventoryType}',
			pageName: '{client}:{inventoryType}:si:vls',
			toolDescriptor: 'vls:window sticker'
		},
		event: {
			action: 'window sticker|tool'
		},
		directCall: 'window-sticker'
	},
	'windowsticker-vdp': {
		onclick: {
			onclick:
				'{inventoryType}:si:vehicle details:view window sticker:{nameplate}',
			onclickLinkName:
				'{client}:{inventoryType}:si:vehicle details:view window sticker:{nameplate}'
		},
		page: {
			toolDescriptor: 'vehicle details:window sticker',
			tool: 'event:window sticker',
			hierarchy:
				'shopping tools:search inventory:{inventoryType}:{nameplate}',
			pageName: '{client}:{inventoryType}:si:vehicle details'
		},
		event: {
			action: 'window sticker|tool'
		},
		directCall: 'window-sticker'
	},
	'slideshow-prev': {
		onclick: {
			onclick: 'home:content:carousel scroll:left',
			onclickLinkName: '{client}:home:content:action:{nameplate}'
		},
		page: {
			pageName: '{client}:home',
			pageNameNoVehicle: '{client}:home',
			hierarchy: 'home',
			siteSection: 'home'
		}
	},
	'slideshow-next': {
		onclick: {
			onclick: 'home:content:carousel scroll:right',
			onclickLinkName: '{client}:home:content:action:{nameplate}'
		},
		page: {
			pageName: '{client}:home',
			pageNameNoVehicle: '{client}:home',
			hierarchy: 'home',
			siteSection: 'home'
		}
	},
	'staff-click': {
		onclick: {
			onclick: 'about us:meet our staff:photo click',
			onclickLinkName: '{client}:about us:meet our staff:content:action'
		}
	},
	'black-label-navigator-themekit-learn-more': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln navigator',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-nautilus-themekit-learn-more': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln nautilus',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-aviator-themekit-learn-more': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln aviator',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-navigator-invitation-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln navigator:invitation theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-navigator-centralpark-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln navigator:central park theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-navigator-chalet-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln navigator:chalet theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-aviator-flight-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln aviator:flight theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-aviator-destination-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln aviator:destination theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-aviator-chalet-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln aviator:chalet theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-nautilus-redwood-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln nautilus:redwood theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-nautilus-chalet-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln nautilus:chalet theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-search-inventory-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick: 'ownership:black label:content:search inventory',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-search-inventory-click-navigator': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:search inventory:lincoln navigator',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-search-inventory-click-aviator': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:search inventory:lincoln aviator',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-search-inventory-click-nautilus': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:search inventory:lincoln nautilus',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'blog-list-tag': {
		onclick: {
			onclick: 'about us:blog:content:tag',
			onclickLinkName: '{client}:about us:blog:content:action'
		}
	},
	'blog-post-tag': {
		onclick: {
			onclick: 'about us:blog:{pageTitle}:content:tag',
			onclickLinkName: '{client}:about us:blog:{pageTitle}:content:action'
		}
	},
	'coupon-scroll-battery': {
		onclick: {
			onclick: 'battery service advice:content:scroll offers',
			onclickLinkName:
				'{client}:service:battery service advice:content:action'
		}
	},
	'coupon-scroll-brakes': {
		onclick: {
			onclick: 'brake service advice:content:scroll offers',
			onclickLinkName:
				'{client}:service:brake service advice:content:action'
		}
	},
	'coupon-scroll-tires': {
		onclick: {
			onclick: 'tire service advice :content:scroll offers',
			onclickLinkName:
				'{client}:service:tire service advice:content:action'
		}
	},
	'print-battery': {
		onclick: {
			onclick: 'battery service advice:content:print offer',
			onclickLinkName:
				'{client}:service:battery service advice:content:action'
		}
	},
	'print-brakes': {
		onclick: {
			onclick: 'brake service advice:content:print offer',
			onclickLinkName:
				'{client}:service:brake service advice:content:action'
		}
	},
	'print-tires': {
		onclick: {
			onclick: 'tire service advice:content:print offer',
			onclickLinkName:
				'{client}:service:tire service advice:content:action'
		}
	},
	'schedule-battery': {
		onclick: {
			onclick: 'battery service advice:content:schedule service',
			onclickLinkName:
				'{client}:service:battery service advice:content:action'
		}
	},
	'schedule-brakes': {
		onclick: {
			onclick: 'brake service advice:content:schedule service',
			onclickLinkName:
				'{client}:service:brake service advice:content:action'
		}
	},
	'schedule-general': {
		onclick: {
			onclick: 'general service advice:content:schedule service',
			onclickLinkName:
				'{client}:service:general service advice:content:action'
		}
	},
	'schedule-oil': {
		onclick: {
			onclick: 'oil change advice:content:schedule service',
			onclickLinkName: '{client}:service:oil change advice:content:action'
		}
	},
	'schedule-tires': {
		onclick: {
			onclick: 'tire service advice:content:schedule service',
			onclickLinkName:
				'{client}:service:tire service advice:content:action'
		}
	},
	schedule_delivery_1: {
		onclick: {
			onclick: 'pickup and delivery:content:schedule service',
			onclickLinkName: '{client}:pickup and delivery:content:action'
		}
	},
	accordion_delivery_1: {
		onclick: {
			onclick: 'pickup and delivery:content:accordion:{title}:open',
			onclickLinkName: '{client}:pickup and delivery:content:action'
		}
	},
	pager: {
		onclick: {
			onclickLinkName: '{client}:home:content:action:{nameplate}'
		},
		page: {
			pageName: '{client}:home',
			pageNameNoVehicle: '{client}:home',
			hierarchy: 'home',
			siteSection: 'home'
		}
	},
	'payment-calculator': {
		onclick: {
			onclick:
				'{client}:{inventoryType}:si:vehicle details:payment calculator',
			onclickLinkName:
				'{client}:{inventoryType}:si:vehicle details:payment calculator',
			tool: 'event:payment estimator',
			toolDescriptor: 'vehicle details:payment estimator'
		}
	},
	'finance-center': {
		onclick: {
			onclick: 'finance:finance department:content:accordion',
			onclickLinkName:
				'{client}:finance:finance department:content:action'
		}
	},
	'finance-application': {
		page: {
			pageName: '{client}:finance:get pre-approved',
			siteSection: 'finance',
			hierarchy: 'finance',
			tool: 'event:payment estimator',
			toolDescriptor: 'vehicle details:payment estimator'
		},
		onclick: {
			onclick: '{inventoryType}:si:vehicle details:payment calculator',
			onclickLinkName:
				'{client}:{inventoryType}:si:vehicle details:payment calculator'
		}
	},
	'ford-pass-apple-app-top': {
		onclick: {
			onclick:
				'service:fordpass landingpage:content:app download:apple:top',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'ford-pass-android-app-top': {
		onclick: {
			onclick:
				'service:fordpass landingpage:content:app download:google:top',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'ford-pass-android-app-bottom': {
		onclick: {
			onclick:
				'service:fordpass landingpage:content:app download:google:bottom',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'collision-page-link': {
		onclick: {
			onclick: 'collision:content:{collisionClickType}',
			onclickLinkName: '{client}:service:collision:content:action'
		}
	},
	'shop-accessories': {
		onclick: {
			onclick: 'shop accessories:content:shop accessories',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'accessories-referral-exit'
	},
	'accessories-referral-exit': {
		onclick: {
			onclick: 'referral:gfa:home',
			onclickLinkName: 'referral:exit',
			referredTo: 'gfa:home'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'ford-blue-advantage-search-inventory': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:content:search inventory',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:content:action'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		}
	},
	'lincoln-cpo-overview-general-click': {
		onclick: {
			onclick: 'cpo overview:content:click',
			onclickLinkName:
				'{client}:used:si:cpo overview:content:action:click'
		}
	},
	'ford-blue-advantage-search-download-gold': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:brochure download:gold certified',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:download'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'ford-blue-advantage-search-download-blue': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:brochure download:blue certified',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:download'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'ford-blue-advantage-search-download-172': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:brochure download:172 point checklist',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:download'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'ford-blue-advantage-search-download-139': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:brochure download:139 point checklist',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:download'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'ford-parts-page-enrolled': {
		onclick: {
			onclick: 'referral:fpol:find dealer:vanity landing',
			onclickLinkName: 'referral:exit',
			referredTo: 'fpol:find dealer:vanity landing'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'ford-parts-page-not-enrolled': {
		onclick: {
			onclick: 'referral:generic',
			onclickLinkName: 'referral:exit',
			referredTo: 'generic'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'model-e-buy-now-srp': {
		onclick: {
			onclick:
				'{inventoryType}:si:{vehiclePageType}:content:model e buy now',
			onclickLinkName:
				'{client}:{inventoryType}:si:{vehiclePageType}:content:action:{nameplate}',
			referredTo: 'model e buy now'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'model-e-buy-now-vdp': {
		onclick: {
			onclick: '{inventoryType}:si:{vehiclePageType}:model e buy now',
			onclickLinkName:
				'{client}:{inventoryType}:si:{vehiclePageType}:content:action:{nameplate}',
			referredTo: 'model e buy now'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'ford-adchoices': {
		onclick: {
			onclick: 'help:aboutads',
			onclickLinkName: '{client}:help:aboutads'
		},
		page: {
			pageName: '{client}:help:aboutads'
		}
	}
};

export default linkTypeMapping;
